import { SVGProps } from "react";

const CheckerEyeUnlocked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7028_15896)">
      <path
        d="M11.0149 9.37886C12.4405 9.37886 13.5962 8.22198 13.5962 6.7949C13.5962 5.36782 12.4405 4.21094 11.0149 4.21094C9.58928 4.21094 8.43359 5.36782 8.43359 6.7949C8.43359 8.22198 9.58928 9.37886 11.0149 9.37886Z"
        fill="#8E8E93"
      />
      <path
        d="M12.8439 11.0405C12.7099 11.108 12.5721 11.1676 12.4313 11.2188C12.5743 11.1712 12.7146 11.1169 12.851 11.056H12.8565L12.8439 11.0405ZM6.55143 7.00316C6.55058 6.34739 6.69414 5.69963 6.97169 5.10686L6.93717 5.07142C6.58343 5.84239 6.45481 6.69937 6.56643 7.54166C6.67805 8.38394 7.02527 9.17654 7.56729 9.82631C6.91561 9.03237 6.55659 8.03463 6.55143 7.00316ZM11.0187 2.45313C10.4366 2.45195 9.85977 2.56477 9.32012 2.78533L9.38369 2.84956C9.89691 2.63544 10.4465 2.5243 11.0017 2.52234C11.5855 2.51891 12.1642 2.6323 12.7044 2.85599C13.2446 3.07968 13.7356 3.40924 14.1492 3.82565C14.5627 4.24206 14.8905 4.73708 15.1138 5.28216C15.337 5.82724 15.4512 6.41159 15.4498 7.0015C15.4498 7.5642 15.3341 8.12076 15.1101 8.63592L15.1649 8.69129C15.3959 8.14046 15.5146 7.54824 15.5139 6.95001C15.5101 4.46626 13.4992 2.45313 11.0187 2.45313Z"
        fill="#8E8E93"
      />
      <path
        d="M11 1.70601e-05C9.70059 -0.00217866 8.40931 0.20759 7.17602 0.621231C6.07591 0.986903 5.03087 1.5039 4.07034 2.15765C1.54986 3.79208 0.00195312 6.03332 0.00195312 6.99614C0.00195312 8.65714 4.53115 14 11.0022 14C12.3896 14.0032 13.7668 13.7595 15.0706 13.2803C16.16 12.9131 17.192 12.3911 18.1357 11.73C20.4973 10.1277 22.0019 7.96229 22.0019 6.9978C21.9998 5.34511 17.5511 1.70601e-05 11 1.70601e-05ZM15.161 8.69258C14.7158 9.74588 13.8924 10.5898 12.8564 11.0545H12.8509C12.7145 11.1154 12.577 11.1697 12.4312 11.2173C11.9719 11.3825 11.4876 11.4659 11 11.4637C10.3459 11.4637 9.69975 11.3178 9.10786 11.0363C8.51597 10.7548 7.99289 10.3447 7.57601 9.83534C7.57272 9.83202 7.56998 9.82815 7.56724 9.82482C7.02522 9.17506 6.678 8.38246 6.56638 7.54017C6.45476 6.69789 6.58338 5.84091 6.93712 5.06994C7.30007 4.28607 7.877 3.62324 8.60006 3.15941C9.32311 2.69557 10.1622 2.45003 11.0187 2.45165C13.4992 2.45165 15.5117 4.46478 15.5117 6.94797C15.5122 7.54725 15.3929 8.14101 15.161 8.69258Z"
        fill="#8E8E93"
      />
      <path
        d="M9.38292 2.85329C8.84665 3.03676 8.35473 3.3325 7.93929 3.72118C7.52385 4.10986 7.19425 4.58274 6.97202 5.10892L6.9375 5.07349C7.4169 4.03518 8.26776 3.21894 9.31881 2.78906L9.38292 2.85329Z"
        fill="#8E8E93"
      />
      <path
        d="M15.162 8.69042C14.7168 9.74373 13.8934 10.5876 12.8574 11.0524C13.881 10.5605 14.6846 9.69848 15.1094 8.63672L15.162 8.69042Z"
        fill="#8E8E93"
      />
    </g>
    <defs>
      <clipPath id="clip0_7028_15896">
        <rect width="22" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CheckerEyeUnlocked;
